import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';

/**
 * The old Library route (`promote/promoteLibrary`). Releases v2 (owner, 2026-10-07): assets live
 * only in their release, so the Library left the Promote menu. A saved link opens the Releases
 * list. The query stays, so `?accountId=` still selects the artist.
 */
const PromoteLibraryRedirectComponent: React.FC = () => {
  const { search } = useLocation();

  return <Navigate to={`/${SMLRouteNames.promote}${search}`} replace />;
};

export const PromoteLibraryRedirect = TypedMemo(PromoteLibraryRedirectComponent);
